import gql from 'graphql-tag'

export const eligibilityTemplateCreate = gql`
  mutation EligibilityTemplateCreate($input: EligibilityTemplateCreateInput!) {
    eligibilityTemplateCreate(input: $input) {
      success
    }
  }
`
